import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';

import useTranslation from '../../../hooks/use_translation';

const ExpandableText = ({ children, maxHeight = 500, mobileOnly = false }) => {
	const { t } = useTranslation('component_expandable_text');
	const [expanded, setExpanded] = useState(false);
	const [isOverflowing, setIsOverflowing] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const contentRef = useRef(null);
	const MAX_HEIGHT = maxHeight;

	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		checkScreenSize();
		window.addEventListener('resize', checkScreenSize);
		return () => window.removeEventListener('resize', checkScreenSize);
	}, []);

	useEffect(() => {
		if (contentRef.current && (!mobileOnly || isMobile)) {
			setIsOverflowing(contentRef.current.scrollHeight > MAX_HEIGHT);
		}
	}, [children, isMobile, mobileOnly]);

	if (mobileOnly && !isMobile) {
		return <div className="expandable-text-content">{children}</div>;
	}

	return (
		<div className="expandable-text-container">
			<div
				className={`expandable-text-content pb-5 ${expanded ? 'expanded' : ''}`}
				ref={contentRef}
				style={{ maxHeight: expanded ? 'none' : `${MAX_HEIGHT}px` }}
			>
				{children}
			</div>
			{isOverflowing && (
				<div
					aria-controls="expandable-text-content"
					aria-expanded={expanded}
					aria-label={expanded ? t('t2') : t('t1')}
					className="expandable-text-button-wrapper d-flex justify-content-center"
					onClick={() => setExpanded(!expanded)}
					role="button"
				>
					<button className="expandable-text-button rounded-pill btn btn-dark">
						{expanded ? (
							<>
								{t('t2')} <ChevronUp />
							</>
						) : (
							<>
								{t('t1')} <ChevronDown />
							</>
						)}
					</button>
				</div>
			)}
			{isOverflowing && !expanded && <div className="fade-overlay"></div>}
		</div>
	);
};

ExpandableText.propTypes = {
	children: PropTypes.node.isRequired,
	maxHeight: PropTypes.number,
	mobileOnly: PropTypes.bool,
};

export default ExpandableText;
